import { CssBaseline } from '@mui/material';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from 'routing';
import { useService } from 'shared/providers';
import { RegisterAppUpdate } from 'startup/register-app-update';
import { gtag } from 'startup/register-google-analytics';

export default function App() {
  const { pathname, search } = useLocation();
  const {
    appConfig: { googleTagId, enableGoogleAnalytics },
  } = useService();

  useEffect(() => {
    if (enableGoogleAnalytics) {
      gtag('config', googleTagId, {
        page_path: pathname + search,
      });
    }
  }, [pathname, search, enableGoogleAnalytics, googleTagId]);

  return (
    <>
      <CssBaseline />
      <RegisterAppUpdate />
      <AppRoutes />
    </>
  );
}
